<!-- Stats panels -->
<div class="goal-stats-container" *ngIf="stats">
  <div class="card no-margin stat-item">
    <div class="stat-icon-container">
      <span class="fal fa-bullseye"></span>
    </div>
    <span class="stats-text">
      <span>
        <span>
          <b>{{stats.numberOfActiveGoals}}</b>
        </span>
        <span class="m-right-5"></span>
        <span translate>{{eGoalMessages.ACTIVE_GOALS}}</span>
      </span>
    </span>
  </div>

  <div class="card no-margin stat-item">
    <div class="round-progress-container">
      <app-progress-bar-round [progress]="stats.averageCompletionPercentage" [showValue]="false" [thickness]="5"
        [size]="60"></app-progress-bar-round>
    </div>
    <span class="stats-text">
      <span>
        <span>
          <b>{{stats.averageCompletionPercentage | number : '1.2-2'}}%</b>
        </span>
        <span class="m-right-5"></span>
        <span translate>{{eGoalMessages.COMPLETE}}</span>
      </span>
    </span>
  </div>

  <div class="card no-margin stat-item">
    <div class="stat-icon-container">
      <span class="fal fa-calendar-alt"></span>
    </div>
    <span class="stats-text">
      <span>
        <span>
          <b>{{stats.numberOfGoalsDueInNext30Days}}</b>
        </span>
        <span class="m-right-5"></span>
        <span translate>{{eGoalMessages.DUE_IN_THE_NEXT_30_DAYS}}</span>
      </span>
    </span>
  </div>

  <div *ngIf="!globals.hasFeature(eCompanyFeatures.GOAL_WEIGHTING); else weightedPercentage"
    class="card no-margin stat-item">
    <div class="stat-icon-container">
      <span class="fal fa-check-circle"></span>
    </div>
    <span class="stats-text">
      <span>
        <span>
          <b>{{stats.numberOfGoalsCompletedInLast3Months}}</b>
        </span>
        <span class="m-right-5"></span>
        <span translate>{{eGoalMessages.COMPLETED_IN_THE_PAST_3_MONTHS}}</span>
      </span>
    </span>
  </div>
  <ng-template #weightedPercentage>
    <div class="card no-margin stat-item">
      <div class="round-progress-container">
        <app-progress-bar-round [progress]="stats.weightedCompletionPercentage" [showValue]="false" [thickness]="5"
          [size]="60"></app-progress-bar-round>
      </div>
      <span class="stats-text">
        <span>
          <span>
            <b>{{stats.weightedCompletionPercentage | number : '1.2-2'}}%</b>
          </span>
          <span class="m-right-5"></span>
          <span translate>{{eGoalMessages.WEIGHTED_COMPLETION}}</span>
        </span>
      </span>
    </div>
  </ng-template>
</div>